import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cbd147ac&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=cbd147ac&prod&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=cbd147ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbd147ac",
  null
  
)

export default component.exports